import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class ChartService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  getScoreTrend(studentId: number): Observable<any> {
    return this.http.get(
      `/api/graph/student/all/test/scores?user_id=${studentId}`,
      this.commonService.getHeaders()
    );
  }

  getQuestionStats(testTypeId: number, studentId: number): Observable<any> {
    return this.http.get(
      `/api/graph/student/answeredQuestionStats/${testTypeId}?user_id=${studentId}`,
      this.commonService.getHeaders()
    );
  }
}
